import {
    AccessSegment,
    ColumnMetadata,
    ColumnTypes,
} from "~/components/DataGrid";
import { Emdash } from "~/components/Punctuation";
import { Badge, BadgeVariants } from "~/components/Badge";
import { AssetColumns } from "~/modules/assets/types";
import { AssetTableRowData } from "../types";

export const SP_RATING_COLUMN: ColumnMetadata<AssetTableRowData, AssetColumns> =
    {
        slug: "S&P Assessment",
        label: (
            <>
                S&amp;P Stability
                <br />
                Assessment
            </>
        ),
        tooltip:
            "S&P Global Ratings Stablecoin Stability Assessment is designed to provide market stakeholders with transparency into the stability of various stablecoins and specific insight into their depegging risks.",
        type: ColumnTypes.string,
        sortsOn: "spRating" as AssetColumns,
        width: 160,
        access: {
            view: AccessSegment.Preview,
            sort: AccessSegment.Preview,
        },
        render: (item) => {
            if (item.isAsset) {
                if (!item.sp_rating || !item.ticker) {
                    return (
                        <div className="flex justify-center">
                            <Emdash />
                        </div>
                    );
                }

                // Map each number grade to a badge color
                const BadgeGrades = {
                    1: BadgeVariants.green,
                    2: BadgeVariants.blue,
                    3: BadgeVariants.yellow,
                    4: BadgeVariants.orange,
                    5: BadgeVariants.red,
                };

                const badgeVariant =
                    BadgeGrades[
                        item.sp_rating[0] as "1" | "2" | "3" | "4" | "5"
                    ] || BadgeVariants.gray;

                return (
                    <Badge
                        rounded="sm"
                        className="w-full flex justify-center"
                        label={item.sp_rating}
                        variant={badgeVariant}
                    />
                );
            }

            return (
                <div className="flex justify-center">
                    <Emdash />
                </div>
            );
        },
    };
